export default "__VITE_ASSET__25aef9fb__"